module.exports = __webpack_public_path__ + "img/logo2.1387cb93.png";